import React from "react";
import "../../../styles/SimpleQuizz/ZoneQuestions/ZoneQuestions.css";
import { stringToHTML } from "../../../data/utils";

// Composant qui gère l'affichage des questions

export const ZoneQuestions = ({ dataNumeroId }) => {
  return (
    <main
      className={`zone_question zone_question_${
        dataNumeroId.theme.split(" ")[1]
      }`}
    >
      {/* dataNumeroId.theme donne par exemple "Approche environnementale" comme string, on veut juste "environnementale" utilisé comme style css */}
      <h3 className={`question_title_${dataNumeroId.theme.split(" ")[1]}`}>
        Pétale {dataNumeroId.petale}
        <br></br>
        {dataNumeroId.question}
      </h3>
      <div className="container_detail">
        {dataNumeroId.details.header !== null && (
          <p>{dataNumeroId.details.header}</p>
        )}
        {/* On affiche un titre s'il y en a un */}
        {stringToHTML(dataNumeroId.details.guideline_preambule)}
        <ul>
          {dataNumeroId.details.guidelines.map((line, index) => {
            return <li key={index}>{stringToHTML(line)}</li>;
          })}
        </ul>
      </div>
    </main>
  );
};
